import { Controller } from 'stimulus';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


export default class extends Controller {
  static targets = ['input', 'div', 'address', 'street', 'residentalArea', 'settlement', 'city', 'postalCode', 'county', 'appartmentNumber', 'houseNumber', 'houseName'];

  connect() {
    if (!window.InAadress) return;
    this.id = this.inputTarget.id || uuidv4();
    this.inputTarget.id = this.id;
    this.inAadress = new window.InAadress({
      container: this.id,
      mode: '3',
      nocss: false,
      appartment: 1,
      ihist: '0',
      lang: this.locale,
      fullscreenMode: true,
    });
  }

  addressSelected(event) {
    this.fillFields(event.detail[0]);
    this.inAadress.hideResult();
  }

  fillFields(data) {
    console.log(data);
    const {
      nimi: houseName = '',
      aadress: address = '',
      asum: residental_area = '',
      asustusyksus: settlement = '',
      omavalitsus: city = '',
      liikluspind: street = '',
      aadress_nr: houseNumber = '',
      kort_nr: appartmentNumber = '',
      sihtnumber: postalCode = '',
      maakond: county = '',
    } = data;
    if (this.hasAddressTarget) this.addressTarget.value = address;
    if (this.hasSettlementTarget) this.settlementTarget.value = settlement;
    if (this.hasResidentalAreaTarget) this.residentalAreaTarget.value = residental_area;
    if (this.hasCityTarget) this.cityTarget.value = city;
    if (this.hasStreetTarget) this.streetTarget.value = street;
    if (this.hasHouseNumberTarget) this.houseNumberTarget.value = houseNumber;
    if (this.hasAppartmentNumberTarget) this.appartmentNumberTarget.value = appartmentNumber;
    if (this.hasCountyTarget) this.countyTarget.value = county;
    if (this.hasPostalCodeTarget) this.postalCodeTarget.value = postalCode;
    if (this.hasHouseNameTarget) this.houseNameTarget.value = houseName;
  }

  inaadressLoaded(event) {
    this.divTarget.classList.remove('d-none');
  }

  get locale() {
    if (!this.data.has('locale')) return 'et';

    return this.data.get('locale');
  }
}
